<div class="modal opened">
  <div class="modal-record-player-main">
    <div>
      <ng-container [ngSwitch]="status">
        <!-- here the video and the progrees bar -->
        <ng-template [ngSwitchCase]="STATUS_MEDIA_READY">
          <h2 class="head-custom" *ngIf="header != '' else title">{{header}}</h2>
          <ng-template #title>
            <h2 class="head-def">Thank you for recording a message.</h2>
          </ng-template>
          <p *ngIf="text != '' else subtitle" class="txt" [innerHTML]="text"></p>
          <ng-template #subtitle>
            <p class="txt">You can review your recording below. When you are ready to save the recording, click on Save
              Recording.</p>
          </ng-template>
          <div class="popup-box">
            <div class="popup-video-container">
              <video controls>
                <source [src]="videoSrc">
                Your browser does not support HTML5 video.
              </video>
            </div>
            <div class="video-upload" *ngIf="fileToUpload.status != STATUS_FILE_INITIAL">
              <div class="progressbar" *ngIf="fileToUpload.status == STATUS_FILE_PENDING" role="progressbar"
                [ngStyle]="{ 'width.%': fileToUpload.progress }"><span>Progress bar</span></div>
              <div class="ctn" *ngIf=" fileToUpload.status != STATUS_FILE_SUCCESS"
                [ngClass]="{'complete': fileToUpload.status == STATUS_FILE_SUCCESS, 'fail': fileToUpload.status == STATUS_FILE_ERROR}">
                <core-helpers-box-list-item [close]="true" (onCloseClick)="removeFile(fileToUpload)"
                  [mainText]="getViewName()"></core-helpers-box-list-item>
              </div>
              <core-file-uploaded-list-item *ngIf="fileToUpload.status == STATUS_FILE_SUCCESS" [remove]="true"
                (onRemove)="removeFile(fileToUpload)" [file]="fileToUpload.object"></core-file-uploaded-list-item>
            </div>
          </div>
          <fieldset [ngClass]="{'two-buttons': leftButtonText != ''}">
            <core-helpers-forms-button [type]="'grey'" [text]="leftButtonText" (submit)="onLeftAction()"
              [hidden]="leftButtonText == ''"></core-helpers-forms-button>
            <core-helpers-forms-button-white [disabled]="disabled" [text]="buttonText"
              (submit)="onAction()"></core-helpers-forms-button-white>
          </fieldset>
        </ng-template>
        <ng-template [ngSwitchCase]="STATUS_MEDIA_LOADING">
          <div class="popup-box popup-dimmed">
            <h2 class="head-custom" *ngIf="header != '' else title">{{header}}</h2>
            <ng-template #title>
              <h2 class="head-def">Thank you for recording a message.</h2>
            </ng-template>
              <p class="txt">Your recording is being created below. When ready, you could review and save it.</p>
            <div class="loader">
              <div class="dimmed">
                <div class="dimmed_content">
                  <div class="dimmed_flex_section">
                    <div class="dimmed_info">
                      <div class="dimmed_subtitle"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <fieldset>
              <!-- Only cancel button -->
              <core-helpers-forms-button [type]="'grey'" [text]="leftButtonText" (submit)="onLeftAction()"
                [hidden]="leftButtonText == ''"></core-helpers-forms-button>
            </fieldset>
          </div>
        </ng-template>
        <ng-template [ngSwitchCase]="STATUS_MEDIA_ERROR">
          <div class="popup-box popup-error">
            <core-helpers-box-alert-message-icon [text]="'There was an error playing the media file recorded.'"
              [icon]="'alert'"></core-helpers-box-alert-message-icon>
            <p>Something wrong has happened while the video file, try generating a new one and try it again.</p>

            <fieldset>
              <core-helpers-forms-button [type]="'grey'" [text]="leftButtonText" (submit)="onLeftAction()"
                [hidden]="leftButtonText == ''"></core-helpers-forms-button>
            </fieldset>
          </div>
        </ng-template>
        <ng-template [ngSwitchCase]="STATUS_UPLOAD_ERROR">
          <div class="popup-box popup-error">
            <core-helpers-box-alert-message-icon [text]="'There was an error uploading the file.'"
              [icon]="'alert'"></core-helpers-box-alert-message-icon>
            <p>Something wrong has happened with the video file, try create it again.</p>
            <fieldset>
              <core-helpers-forms-button [type]="'grey'" [text]="leftButtonText" (submit)="onLeftAction()"
                [hidden]="leftButtonText == ''"></core-helpers-forms-button>
            </fieldset>
          </div>
        </ng-template>
      </ng-container>
    </div>
  </div>
</div>